import type { ResearchItem } from "./types";

export const research: ResearchItem[] = [
  {
    slug: "iea-energy-and-ai-2025",
    title: "Energy and AI",
    institution: "International Energy Agency (IEA)",
    year: 2025,
    whyItMatters:
      "The first authoritative attempt by a major energy body to quantify AI's global electricity footprint under multiple scenarios — moving the debate out of anecdote and into modelled ranges that policy can act on.",
    keyFindings: [
      "Global datacenter electricity consumption is projected to roughly double by 2030, with AI workloads the dominant marginal driver.",
      "The largest demand growth is concentrated in a small number of jurisdictions, creating localized grid stress even where national averages look manageable.",
      "AI is a plausible net-positive contributor to emissions reduction only under scenarios that also constrain the carbon intensity of its own infrastructure — an outcome not on the current trajectory.",
    ],
    relevance:
      "Establishes an evidence base for whole-system accounting of AI: whatever efficiency gains AI delivers downstream must be netted against the infrastructure load documented here. Without that netting, ‘AI for climate’ claims remain unaudited.",
    relatedIdeas: ["can-ai-solve-the-climate-crisis", "the-energy-paradox-of-artificial-intelligence"],
    relatedConcepts: ["ai-sustainability-paradox", "efficiency-debt"],
    sourceUrl: "https://www.iea.org/reports/energy-and-ai",
    topics: ["AI", "Energy", "Climate"],
    updated: "2026-07-06",
  },
  {
    slug: "unep-state-of-finance-for-nature-2026",
    title: "State of Finance for Nature 2026",
    institution: "United Nations Environment Programme (UNEP)",
    year: 2026,
    whyItMatters:
      "Quantifies the imbalance between finance that harms nature and finance that protects it — approximately 30:1 in favour of destructive flows — reframing the sustainability transition as primarily a capital-allocation problem rather than a technology problem.",
    keyFindings: [
      "Nature-negative finance flows now exceed USD 7 trillion annually, against approximately USD 220 billion in nature-positive investment.",
      "Public subsidies remain a major channel of nature-negative finance in most economies.",
      "Closing even a fraction of the gap would require redirection at a scale that is politically, not technically, constrained.",
    ],
    relevance:
      "Situates AI's role in sustainability inside the actual bottleneck: the constraint is not analytic capacity but capital-allocation rules. Technologies that improve measurement without changing allocation logic address the wrong problem.",
    relatedIdeas: ["can-ai-solve-the-climate-crisis"],
    relatedConcepts: ["institutional-blindness", "ai-sustainability-paradox"],
    sourceUrl: "https://www.unep.org/resources/state-finance-nature",
    topics: ["Sustainability", "Governance", "Climate"],
    updated: "2026-07-06",
  },
];

export const researchBySlug = (slug: string): ResearchItem | undefined =>
  research.find((r) => r.slug === slug);
